var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"banner"}},[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":require('@images/banner.jpg')}})]),_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":require('@images/icons/mouse.png')}})])])}
var staticRenderFns = []

export { render, staticRenderFns }